import { render, staticRenderFns } from "./castTable.vue?vue&type=template&id=2b980911&scoped=true&slot-scope=scope&"
import script from "./castTable.vue?vue&type=script&lang=js&"
export * from "./castTable.vue?vue&type=script&lang=js&"
import style0 from "./castTable.vue?vue&type=style&index=0&id=2b980911&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b980911",
  null
  
)

export default component.exports